/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I save the chart?`)
};

const es_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo guardo el gráfico?`)
};

const de_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie speichere ich das Diagramm?`)
};

const nl_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe sla ik de grafiek op?`)
};

const fr_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment enregistrer le graphique ?`)
};

const it_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come salvo il grafico?`)
};

const pt_br2_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como salvo o gráfico?`)
};

const pt_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como guardo o gráfico?`)
};

const ja_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グラフを保存するには？`)
};

const zh_bar_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何保存图表？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_faq_q4", locale)
	if (locale === "en") return en_bar_faq_q4(inputs)
	if (locale === "es") return es_bar_faq_q4(inputs)
	if (locale === "de") return de_bar_faq_q4(inputs)
	if (locale === "nl") return nl_bar_faq_q4(inputs)
	if (locale === "fr") return fr_bar_faq_q4(inputs)
	if (locale === "it") return it_bar_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_bar_faq_q4(inputs)
	if (locale === "pt") return pt_bar_faq_q4(inputs)
	if (locale === "ja") return ja_bar_faq_q4(inputs)
	return zh_bar_faq_q4(inputs)
};